(function($) {

    $(function() {
        var body = $('body');

        if(body.hasClass('home')) {
            let mainCarousel = $('.process-carousel').owlCarousel({
                loop: true,
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 50,
                autoplayTimeout: 7000,
                autoplay: false,
                margin: 0,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                touchDrag: false,
                //mouseDrag: false,
            });

            const TIMEOUT_POINTS = {
                min: 1000,
                max: 5000
            }
            let mainCarouselTimeout = TIMEOUT_POINTS.max;
            let owlItem = mainCarousel.find('.owl-item.active .process-item');

            if(owlItem.data('inner')) {
                mainCarouselTimeout = TIMEOUT_POINTS.min;
            }
            setTimeout(() => {
                mainCarousel.trigger('next.owl.carousel');
            }, mainCarouselTimeout);

            var mainChangedTimeout = false;
            var innerTimeout = false;

            //Hide bullet from sequences
            var processSlides = $('.process-carousel').find('.owl-item').not('.cloned');
            var processSlidesBullet = [];
            processSlides.each((i, el) => {
                let slide = $(el.children[0]);
                if(!slide.data('first-inner') && slide.data('inner') == 1) {
                    processSlidesBullet.push(false);
                }
                else if(slide.data('last-inner')) {
                    processSlidesBullet.push(false);
                }
                else {
                    processSlidesBullet.push(true);
                }
            });
            var pagBullet = $('.owl-dots button');
            processSlidesBullet.forEach((val, index) => {
                if(!val) {
                    $(pagBullet[index]).hide();
                }
            });

            mainCarousel.on('changed.owl.carousel', function(event) {
                // console.log(event.page.index);
                // console.log(processSlides[event.page.index]);
                let parentSlideIndex = $(processSlides[event.page.index].children[0]).data('parent');
                if(parentSlideIndex != 'undefined') {
                    $(pagBullet[parentSlideIndex]).addClass('active');
                }

                if(mainCarouselTimeout) {
                    clearTimeout(mainCarouselTimeout);
                }
                mainCarouselTimeout = setTimeout(() => {
                    let owlItem = mainCarousel.find('.owl-item.active .process-item');

                    if(owlItem.data('inner')) {
                        mainCarouselTimeout = TIMEOUT_POINTS.min;
                    }
                    else {
                        mainCarouselTimeout = TIMEOUT_POINTS.max;
                    }

                    if(innerTimeout) {
                        clearTimeout(innerTimeout);
                    }
                    innerTimeout = setTimeout(() => {
                        mainCarousel.trigger('next.owl.carousel');

                    }, mainCarouselTimeout);
                }, 300);
            });

            /*==== research =====*/
            $('.research-carousel').owlCarousel({
                loop: true,
                items: 1,
                nav: true,
                dots: true,
                smartSpeed: 900,
                autoplayTimeout: 7000,
                autoplay: true,
                margin: 30,
                navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
                responsive : {
                    // breakpoint from 0 up
                    0 : {
                        items: 1
                    },
                    // breakpoint from 991 up
                    991: {
                        items: 1
                    },
                    // breakpoint from 992 up
                    992: {
                        items: 1
                    }
                }
            });

            /*==== news =====*/
            $('.news-carousel').owlCarousel({
                loop: false,
                rewind: true,
                items: 3,
                nav: true,
                dots: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: true,
                smartSpeed: 500,
                center: false,
                autoplay: true,
                margin: 30,
                navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
                responsive : {
                    // breakpoint from 0 up
                    0 : {
                        items: 1
                    },
                    // breakpoint from 991 up
                    768: {
                        items: 2,
                        center: false
                    },
                    // breakpoint from 992 up
                    992: {
                        items: 3
                    }
                }
            });

        }

    });


})(jQuery);
